<!-- Created by henian.xu on 2018/7/20. -->

<template>
    <page>
        <!-- 表单区 -->
        <template slot="secondHeader">
            <el-form
                ref="queryForm"
                class="second-header npa-b"
                size="small"
                :inline="true"
                :model="queryFormModel"
            >
                <el-form-item
                    prop="orderSn"
                    label="订单编号"
                >
                    <el-input
                        v-model="queryFormModel.orderSn"
                        placeholder="请输入订单编号"
                    />
                </el-form-item>
                <el-form-item
                    prop="trackingNumber"
                    label="物流单号"
                >
                    <el-input
                        v-model="queryFormModel.trackingNumber"
                        placeholder="请输入物流单号"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="onQuery()"
                    >
                        查询
                    </el-button>
                    <el-button
                        type="success"
                        @click="onReset"
                    >
                        重置
                    </el-button>
                </el-form-item>
            </el-form>
        </template>

        <!-- 内容 -->
        <div
            class="body"
            slot="body"
            v-loading="querying"
        >
            <!-- 操作 -->
            <div
                class="ma-b"
            >
                <el-button-group>
                    <el-upload
                        class="upload-demo dp-ib ma-l"
                        action="/ex/waybillFreightCost/uploadExcel"
                        :show-file-list="false"
                        accept=".xls,.xlsx"
                        :on-success="onBatchShippingOrderSuccess"
                        :on-error="onBatchShippingOrderError"
                        :headers="{token:$store.getters['Global/User/token']}"
                    >
                        <el-button
                            size="small"
                            type="primary"
                        >
                            excel上传
                        </el-button>
                    </el-upload>
                    <el-button
                        type="danger"
                        icon="el-icon-delete"
                        size="small"
                        @click="onDelete"
                        :disabled="!currentTableSelect.length"
                    >
                        删除
                    </el-button>
                </el-button-group>
            </div>

            <!-- 表格 -->
            <el-table
                stripe
                border
                size="small"
                :data="tableData"
                style="width: 100%"
                @selection-change="onTableSelectionChange"
            >
                <el-table-column
                    type="selection"
                    width="36"
                />
                <el-table-column
                    prop="orderSn"
                    label="订单编号"
                    min-width="100"
                />
                <el-table-column
                    prop="trackingNumber"
                    label="物流单号"
                    min-width="100"
                />
                <el-table-column
                    prop="packageWeight"
                    label="包裹重量"
                    min-width="100"
                />
                <el-table-column
                    prop="freightAmount"
                    label="运费金额"
                    min-width="100"
                />
                <el-table-column
                    prop="taxAmount"
                    label="物流税金"
                    min-width="100"
                />
                <el-table-column
                    prop="materialAmount"
                    label="耗材费用"
                    min-width="100"
                />
                <el-table-column
                    prop="otherAmount"
                    label="其他费用"
                    min-width="100"
                />
                <el-table-column
                    prop="totalAmount"
                    label="物流总费用"
                    min-width="100"
                />
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="90"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="onTableEdit(scope.row)"
                        >
                            编辑
                        </el-button>
                        <el-button
                            type="text"
                            size="small"
                            @click="onTableDelete(scope.row.id)"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="ma-t ta-r">
                <pagination
                    v-model="pagination"
                    @input="onQuery"
                />
            </div>
        </div>

        <!-- 弹框 -->
        <!-- 新增/编辑 -->
        <el-dialog
            :title="addDialog.formModel.id ? '编辑' : '新增'"
            center
            width="600px"
            :visible.sync="addDialog.isVisible"
            @closed="onAddDialogCancel"
        >
            <el-form
                ref="addForm"
                size="small"
                :model="addDialog.formModel"
                :rules="addDialog.formRules"
            >
                <el-form-item
                    prop="orderSn"
                    label="订单编号"
                    label-width="6em"
                >
                    {{ addDialog.formModel.orderSn }}
                </el-form-item>
                <el-form-item
                    prop="trackingNumber"
                    label="物流单号"
                    label-width="6em"
                >
                    {{ addDialog.formModel.trackingNumber }}
                </el-form-item>
                <el-form-item
                    prop="packageWeight"
                    label="包裹重量"
                    label-width="6em"
                >
                    <el-input-number
                        controls-position="right"
                        :min="0"
                        :precision="2"
                        v-model.number="addDialog.formModel.packageWeight"
                    />
                </el-form-item>
                <el-form-item
                    prop="freightAmount"
                    label="运费金额"
                    label-width="6em"
                >
                    <el-input-number
                        controls-position="right"
                        :min="0"
                        :precision="2"
                        v-model.number="addDialog.formModel.freightAmount"
                    />
                </el-form-item>
                <el-form-item
                    prop="taxAmount"
                    label="物流税金"
                    label-width="6em"
                >
                    <el-input-number
                        controls-position="right"
                        :min="0"
                        :precision="2"
                        v-model.number="addDialog.formModel.taxAmount"
                    />
                </el-form-item>
                <el-form-item
                    prop="materialAmount"
                    label="耗材费用"
                    label-width="6em"
                >
                    <el-input-number
                        controls-position="right"
                        :min="0"
                        :precision="2"
                        v-model.number="addDialog.formModel.materialAmount"
                    />
                </el-form-item>
                <el-form-item
                    prop="otherAmount"
                    label="其他费用"
                    label-width="6em"
                >
                    <el-input-number
                        controls-position="right"
                        :min="0"
                        :precision="2"
                        v-model.number="addDialog.formModel.otherAmount"
                    />
                </el-form-item>
            </el-form>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    type="primary"
                    size="small"
                    @click="onAddDialogConfirm"
                >
                    确 定
                </el-button>
                <el-button
                    size="small"
                    @click="onAddDialogCancel"
                >
                    取 消
                </el-button>
            </div>
        </el-dialog>
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';
import { queryFormList } from 'vmf/src/mixin';

export default {
    name: 'WaybillFeightCost',
    mixins: [pagesMixin, queryFormList],
    data() {
        return {
            queryFormModel: {
                orderSn: '', // 订单编号
                trackingNumber: '', // 物流单号
            },
            // 新增/编辑
            addDialog: {
                // 对话框显示
                isVisible: false,
                // 表单数据
                formModel: {
                    id: '',
                    orderSn: '',
                    trackingNumber: '',
                    packageWeight: '',
                    freightAmount: '',
                    taxAmount: '',
                    materialAmount: '',
                    otherAmount: '',
                },
                // 表单校验规则
                formRules: {
                    packageWeight: {
                        required: true,
                        message: '请输入包裹重量',
                        trigger: 'blur',
                    },
                    freightAmount: {
                        required: true,
                        message: '请输入运费成本',
                        trigger: 'blur',
                    },
                    taxAmount: {
                        required: true,
                        message: '请输入物流税金',
                        trigger: 'blur',
                    },
                    materialAmount: {
                        required: true,
                        message: '请输入耗材费用',
                        trigger: 'blur',
                    },
                    otherAmount: {
                        required: true,
                        message: '请输入其他费用',
                        trigger: 'blur',
                    },
                },
            },
            // 表格数据
            tableData: [],
            // 表格当前选中行
            currentTableSelect: [],
        };
    },
    methods: {
        /* -- 方法 -- */
        // 请求列表数据
        getListData(queryData) {
            return this.$api.Ex.WaybillFreightCost.data(queryData).then(json => {
                const res = json.data;
                this.tableData = res.data;
                this.pagination = res.pagination;
                return Promise.resolve(json);
            });
        },
        /* -- 事件 -- */
        onTableSelectionChange(val) {
            this.currentTableSelect = val;
        },
        onTableEdit(row) {
            const { formModel } = this.addDialog;
            this.$api.Ex.WaybillFreightCost.getDetail({ id: row.id }).then(json => {
                const res = json.data.data;
                this.$utils.Common.formModelMerge(formModel, res);
            });
            this.addDialog.isVisible = true;
        },
        onTableDelete(ids) {
            this.$confirm('是否确定要删除！', '温馨提示', {
                type: 'warning',
            }).then(() => {
                this.$api.Ex.WaybillFreightCost.delete({ ids }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onQuery(this.pagination);
                });
            });
        },
        onDelete() {
            const ids = this.currentTableSelect.reduce((prev, next) => {
                prev.push(next.id);
                return prev;
            }, []);
            this.onTableDelete(ids.join(','));
        },
        onAddDialogConfirm() {
            const { addForm } = this.$refs;
            addForm.validate().then(() => {
                this.$api.Ex.WaybillFreightCost.save({
                    ...this.addDialog.formModel,
                }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onQuery(this.pagination);
                    this.addDialog.isVisible = false;
                });
            });
        },
        onAddDialogCancel() {
            const { addForm } = this.$refs;
            addForm.resetFields();
            const { formModel } = this.addDialog;
            formModel.id = '';
            this.addDialog.isVisible = false;
        },
        onBatchShippingOrderSuccess(response) {
            if (response.success) {
                this.$message({
                    message: response.msg,
                    type: 'success',
                });
                this.onQuery(this.pagination);
            } else {
                this.$alert(response.msg, '错误提示', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                });
            }
        },
        onBatchShippingOrderError(err) {
            this.$message({
                message: err,
                type: 'error',
            });
        },
    },
};
</script>

<style lang="scss">
</style>
